<template>
	<div class="full" id="stafflifecycleStatisticsChart"></div>
</template>
<style>

</style>
<style scoped>

</style>
<script>
	import * as echarts from 'echarts';
	export default {
		props: {
			kpi: {
				default: () => {
					return []
				}
			},
			formData: {
				default: () => {
					return null
				}
			},
			tableData: {
				type: Array,
				default: () => {
					return []
				}
			},
			chartField: {
				default: () => {
					return 'validReplyUv1d'
				}
			},
			chartTitle: {
				default: () => {
					return '有效接待人数'
				}
			}
		},
		data() {
			return {
				chart: null,
				//singleField: ['fstReplyDur1d', 'avgReplyDur1d', 'conversionrate']
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {
			//this.statisticsChart()
		},
		computed: {

		},

		methods: {
			createChart() {
				let type = 'total'
				let xfield = 'targetstaffid'
				if (this.formData.targetstaffid) {
					type = 'single'
				}
				this.statisticsChart(type, xfield)
			},
			statisticsChart(type = "total", xfield = "targetstaffid") {
				let field = this.chartField
				let title = this.chartTitle
				console.log(type, title)
				let shopname = []
				let xarr = []
				let tableData = JSON.parse(JSON.stringify(this.tableData))
				let series = []
				if (type == 'total') {
					xarr = tableData.map((item) => {
						return this.$systemMethods.getstaff(item[xfield])
					})
					xarr = [...new Set(xarr)]
				} else {
					xarr = this.tableData.map((item) => {
						return this.$systemMethods.timestampToDate(item['static_time'], true)
					})
				}
				let kpi = this.kpi[field]
				let bardata = tableData.map((item) => {
					let barcolor = '#909399'
					for (let i in kpi) {
						console.log(field)
						if(field=='fstReplyDur1d' || field=='avgReplyDur1d'){
							if (item[field] <= kpi[i]) {
								if (i == 'A') {
									barcolor = '#67C23A'
									break
								}
								if (i == 'B') {
									barcolor = '#E6A23C'
									break
								}
								if (i == 'C') {
									barcolor = '#F56C6C'
									break
								}
							}
						}else{
							if (item[field] >= kpi[i]) {
								if (i == 'A') {
									barcolor = '#67C23A'
									break
								}
								if (i == 'B') {
									barcolor = '#E6A23C'
									break
								}
								if (i == 'C') {
									barcolor = '#F56C6C'
									break
								}
							}
						}
					}
					return {
						value: item[field],
						itemStyle: {
							color: barcolor
						}
					}
				})

				console.log(bardata)
				series.push({
					name: title,
					type: 'bar',
					emphasis: {
						focus: 'series'
					},
					data: bardata
				})


				for (let i in kpi) {
					let name = '合格'
					let color = '#F56C6C'
					if (i == 'A') {
						name = '优'
						color = '#67C23A'
					}
					if (i == 'B') {
						name = '良'
						color = '#E6A23C'
					}
					series.push({
						name: name,
						type: 'line',
						smooth: true,
						lineStyle: {
							color: color
						},
						itemStyle: {
							color: color
						},
						emphasis: {
							focus: 'series'
						},
						data: tableData.map(() => {
							return kpi[i]
						})
					})
				}
				console.log(series)


				if (this.chart) {
					this.chart.clear()
				} else {
					this.chart = echarts.init(document.getElementById('stafflifecycleStatisticsChart'))
				}
				this.chart.setOption({
					title: {
						text: '',

						textStyle: {
							fontSize: 14
						}
					},
					legend: {
						data: shopname
					},
					grid: {
						left: '3%',
						right: '4%',
						bottom: '3%',
						containLabel: true
					},
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'shadow'
						}
					},
					toolbox: {
						show: true,
						orient: 'vertical',
						left: 'right',
						top: 'center',
						feature: {
							mark: {
								show: true
							},
							dataView: {
								show: true,
								readOnly: false
							},
							magicType: {
								show: true,
								type: ['line', 'bar', 'stack']
							},
							restore: {
								show: false
							},
							saveAsImage: {
								show: true
							}
						}
					},
					xAxis: {
						data: xarr
					},
					yAxis: {},
					series: series
				})
			},
			groupBySum(array, groupKey, sumKey) {
				//console.log(array, groupKey, sumKey)
				return array.reduce((accumulator, item) => {
					let group = accumulator.find(i => i[groupKey] === item[groupKey]);
					if (group) {
						group[sumKey] += item[sumKey] ? parseFloat(item[sumKey]) : 0;
					} else {
						let newGroup = {};
						newGroup[groupKey] = item[groupKey];
						newGroup[sumKey] = parseFloat(item[sumKey]);
						accumulator.push(newGroup);
					}

					return accumulator;
				}, []);
			}
		},
		components: {

		}
	}
</script>